import React from 'react';
import Grid from '../layout/grid';
import { withRouter } from 'react-router-dom';
import './modernValueBox.css';

const ModernValueBox = props => {
  const handleClick = () => {
    if (props.onClick) {
      props.onClick();
    } else if (props.route) {
      props.history.push(props.route);
    }
  };

  const isClickable = props.onClick || props.route;

  return (
    <Grid cols={props.cols}>
      <div
        className={`modern-value-box bg-${props.color} ${isClickable ? 'clickable' : ''}`}
        style={{
          textAlign: `${props.position}`,
        }}
        onClick={isClickable ? handleClick : undefined}
      >
        <div className="modern-inner">
          <div className="modern-icon-corner">
            <i className={`fa fa-${props.icon}`} />
          </div>
          <div className="modern-content">
            <h3 className="modern-value">{props.value}</h3>
            <p className="modern-text">{props.text}</p>
          </div>
        </div>
        {isClickable && (
          <div className="modern-footer">
            <span className="modern-link">
              <i className="fa fa-arrow-circle-right" style={{ paddingRight: '5px' }} /> Ver detalhes
            </span>
          </div>
        )}
      </div>
    </Grid>
  );
};

export default withRouter(ModernValueBox);
